<ng-container>
    <sl-home [layoutKey]="LayoutKeyEnum.GeneralMeeting" [fixedConfig]="dashboardConfiguration" />
</ng-container>
